import React, { FC, useEffect, useState }              from "react";
import { useDispatch }                                 from "react-redux";
import { Button, Icon, Message, Segment, Step, Table } from "semantic-ui-react";
import GetPaymentInformation
                                                       from "../../../application/usecase/payment/GetPaymentInformetion";
import RouterDispatcher                                from "../../../infrastructure/redux/router/RouterDispatcher";

const PaymentComplete: FC = () => {
  const [planName, setPlanName] = useState("");
  const [price, setPrice] = useState("");
  const getPaymentInformation: GetPaymentInformation = new GetPaymentInformation(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  useEffect(() => {
    getPaymentInformation.execute(setPlanName, setPrice);
  }, []);

  return (
    <>
      <Step.Group fluid>
        <Step completed disabled>
          <Icon name="check"/>
          <Step.Content>
            <Step.Title>お試し期間終了</Step.Title>
            <Step.Description>お試し期間が終了しました。</Step.Description>
          </Step.Content>
        </Step>
        <Step completed disabled>
          <Icon name="check"/>
          <Step.Content>
            <Step.Title>お申込内容の確認</Step.Title>
            <Step.Description>お申込み時に選択したプランと金額を確認して、決済情報を入力してください。</Step.Description>
          </Step.Content>
        </Step>
        <Step active>
          <Icon name="info"/>
          <Step.Content>
            <Step.Title>決済完了</Step.Title>
            <Step.Description>下記内容で決済が完了しました。</Step.Description>
          </Step.Content>
        </Step>
      </Step.Group>

      <Segment attached>
        <Message positive>
          <Message.Header>ありがとうございます。</Message.Header>
          <p>決済が完了いたしました。引き続きResKaをご利用ください。</p>
        </Message>

        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>お申込み時選択プラン</Table.HeaderCell>
              <Table.HeaderCell>金額(月額)</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{ planName }</Table.Cell>
              <Table.Cell>{ price }円(税込)</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>

      <Segment attached="bottom">
        <Button
          primary
          onClick={ () => routerDispatcher.notice() }
        >
          ResKaに戻る
        </Button>
      </Segment>
    </>
  );
};

export default PaymentComplete;
